import { render, staticRenderFns } from "./validation-action.vue?vue&type=template&id=5aa0b933"
import script from "./validation-action.vue?vue&type=script&lang=js"
export * from "./validation-action.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports